import {Spacing08, Spacing07} from '@RHEnvironmental/pattern-library-tokens';
import {px} from './px';

export const createLicenceStyle = {
  width: '540px',
  gap: px(Spacing07),
  paddingBottom: px(Spacing08),
}